<template>
  <el-dialog
    :title="$t('distributor.批量搜索')"
    :visible.sync="dialog.visible"
    :close-on-click-modal="false"
    :before-close="formReset"
    top="5vh"
  >
    <div class="scroll-box">
      <el-radio-group
        v-model="chooseValue"
        v-for="(item, index) in selectList"
        :key="index"
        @change="changeChooseValue"
      >
        <el-radio :label="item.page">{{ item.name }}</el-radio>
      </el-radio-group>
      <hr />
      <p>
        <span>{{ $t("distributor.每行一个") }}</span>
        <span class="tx-primary">{{ chooseName }}</span>
        <span>{{ $t("distributor.（支持excel复制黏贴）") }}</span>
      </p>
      <el-input type="textarea" :rows="8" v-model="textarea"> </el-input>
      <p class="nll ">当前已添加 <span class="tx-primary">{{SkuNumber}}</span>个商品SKU,最大支持500个SKU</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <button
        type="button"
        class="
          mg-r-5
          btn btn-primary
          tx-11 tx-uppercase
          pd-y-12 pd-x-25
          tx-mont tx-semibold
        "
        @click="save()"
      >
        {{ $t("distributor.确认") }}
      </button>
      <button
        type="button"
        class="
          btn btn-secondary
          tx-11 tx-uppercase
          pd-y-12 pd-x-25
          tx-mont tx-semibold
        "
        @click="formReset()"
      >
        {{ $t("distributor.关闭") }}
      </button>
    </div>
  </el-dialog>
</template> 
<script>
export default {
  name: "batchSearchDialog",
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          visible: false,
          key: "",
        };
      },
    },
  },
  data() {
    return {
      dialogModal: this.dialog,
      chooseValue: "",
      chooseName: "",
      selectList: [],
      textarea: "",
      SkuNumber: 0,
    };
  },
  watch: {
    dialog: {
      handler: function (val) {
        if (val.key) {
          this.getSelection();
        }
      },
      immediate: true,
    },
    textarea(val){
      if (val == '') {
        this.SkuNumber = 0
      }else{
      let str_array = val.split(/[(\r\n)\r\n]+/);
      this.SkuNumber = str_array.length
      console.log(str_array, 'str_array');
      }

    }
  },
  methods: {
    getSelection() {
      $.api_call(
        "api.Config.getBulkSearchFieldsBySupplier",
        {
          m: this.dialogModal.key,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            for (let item in r.Data.Results) {
              this.selectList.push({
                name: r.Data.Results[item],
                page: item,
              });
            }
            console.log(this.selectList);
            this.chooseName = this.selectList[0].name;
            this.chooseValue = this.selectList[0].page
          } else {
            if (r.ErrorCode == "1002") {
              userFailure();
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 重置表单
    formReset() {
      this.dialog.visible = false;
      this.dialog.key = "";
    },
    changeChooseValue() {
      this.chooseName = this.selectList.find(
        (item) => item.page == this.chooseValue
      ).name;
    },
    save() {
      if(this.textarea == ''){
        ShowTip(this.$t('supplier.请输入要搜索的内容,每行一个'), "danger");
        return
      }
      let str_array = this.textarea.split(/[(\r\n)\r\n]+/);
      // console.log(str_array);
      // console.log(this.chooseValue)
      let batchSearch = {
          column: this.chooseValue,
          value: str_array
      }
      this.$emit('handleBatchSearch', batchSearch)
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  border: 1px solid #eee;
  padding: 20px !important;
}
.el-radio-group .el-radio {
  padding: 10px 5px;
}
.scroll-box {
  height: 350px;
  overflow-y: auto;
}
.nll{
  padding: 5px 0;
}
</style>

